




























import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "../../../components/project-detail-header.vue";
import SizhenPatients from "@/components/sizhen-patients/sizhen-patients.vue";
import LeftNav from "../../../components/project-detail-left-nav.vue";
import ProjectSetting from "../../components/project-setting/project-setting.vue";
@Component({
  components: {
    Header,
    LeftNav,
    ProjectSetting,
    SizhenPatients
  }
})
export default class ResearchListImportFromSizhen extends Vue {
  private project: any = {
    project_id: ""
  };
  private groupId: any = "";
  // 项目设置
  private ifShowSet: boolean = false;
  /**
   * @description 获取患者
   */
  private fetchPatients() {
    (this.$refs.sizhenPatients as any).fetchPatients();
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.project.project_id = this.$route.query.projectId;
    this.groupId = this.$route.query.groupId;
  }
}
